
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '../lib/pipe/pipes.module';
import { DateTimePickerComponent } from 'src/app/components/date-time-picker/date-time-picker.component';
import { EmptyListComponent } from './empty-list/empty-list.component';
import { CancelOrderModalComponent } from '../pages/order/cancel-order-modal/cancel-order-modal.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { HeaderComponent } from './header/header.component';
import { AddCatalogModalComponent } from './add-catalog-modal/add-catalog-modal.component';
import { DispatchModalComponent } from './dispatch-modal/dispatch-modal.component';
import { OrderItemComponent } from '../pages/order/order-item/order-item.component';
import { DetailPageSidebarComponent } from '../pages/order/detail-page-sidebar/detail-page-sidebar.component';
import { DeleteQrComponent } from './delete-qr/delete-qr.component';
import { ScanQrcodeComponent } from '../pages/kyc/bank-form/scan-qrcode/scan-qrcode.component';
import { SelectUpiAppComponent } from '../pages/kyc/bank-form/select-upi-app/select-upi-app.component';
import { FaqComponent } from '../pages/user/faq/faq.component';
import { DeliveryDayPreferenceComponent } from './delivery-day-preference/delivery-day-preference.component';
import { DeliveryQuantityComponent } from './delivery-quantity/delivery-quantity.component';
import { OptionsMenuComponent } from './options-menu/options-menu.component';
import { PosLoginComponent } from '../pages/pos/pos-login/pos-login.component';
import { LogoutPopUpComponent } from './logout-pop-up/logout-pop-up.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { ScheduleAutoAssignComponent } from '../pages/order/schedule-auto-assign/schedule-auto-assign.component';
import { WalletPageComponent } from '../pages/wallet-page/wallet-page.component';
import { TimepickerModalComponent } from './timepicker-modal/timepicker-modal.component';
import { FilterModalComponent } from './filter-modal/filter-modal.component';

const COMPONENTS = [
  FooterComponent,
  DateTimePickerComponent,
  EmptyListComponent,
  CancelOrderModalComponent,
  EditProfileComponent,
  HeaderComponent,
  AddCatalogModalComponent,
  DispatchModalComponent,
  DetailPageSidebarComponent,
  OrderItemComponent,
  DeleteQrComponent,
  ScanQrcodeComponent,
  SelectUpiAppComponent,
  FaqComponent,
  PosLoginComponent,
  LogoutPopUpComponent,
  DeliveryQuantityComponent,
  DeliveryDayPreferenceComponent,
  OptionsMenuComponent,
  LogoutPopUpComponent,
  LoaderComponent,
  ScheduleAutoAssignComponent,
  WalletPageComponent,
  TimepickerModalComponent,
  FilterModalComponent
];
@NgModule({
  declarations: [
    ...COMPONENTS
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
  ],
  exports: [
    CommonModule,
    ...COMPONENTS
  ],
})
export class SharedModule { }